module.exports = class ComponentsCollection extends Backbone.Collection
    model: require 'models/component'
